import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scheduleEndNextDay'
})
export class ScheduleEndNextDayPipe implements PipeTransform {

  transform(startTime: any, endTime: any): boolean {
    const start =  startTime && `${startTime.hour < 10 ? '0' + startTime.hour: startTime.hour}:${startTime.minute < 10 ? '0' + startTime.minute: startTime.minute}`
    const end =  endTime && `${endTime.hour < 10 ? '0' + endTime.hour: endTime.hour}:${endTime.minute < 10 ? '0' + endTime.minute: endTime.minute}`
    return start && end ? new Date('1970-01-01T' + end + 'Z').getTime() <  new Date('1970-01-01T' + start + 'Z').getTime():  false;
  }

}
